import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import _ from 'lodash';
import React, { Component } from 'react';
import { Popover, PopoverBody } from '../../../../popovers';
import { constants } from '../../../../../common';

const routineViewFilters = _.values(constants.routineViewTypes);

class RoutineViewSelector extends Component {
   constructor(props) {
      super(props);

      this.state = this.buildFromProps(props);
   }

   buildFromProps(props) {
      return { idRoutineViewType: props.routineViewType.id, filters: routineViewFilters, isOpen: false, broadcast: false };
   }

   handleChange = (name) => (event) => {
      this.setState({
         [name]: event.target.value,
         broadcast: true,
         isOpen: false
      });
   };

   handleToggle = () => {
      const { isOpen } = this.state;
      this.setState({ isOpen: !isOpen });
   };

   UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.idRoutineViewType !== nextProps.routineViewType.id) {
         this.setState(this.buildFromProps(nextProps));
      }
   }

   componentDidUpdate() {
      if (this.state.broadcast) {
         const { idRoutineViewType } = this.state;

         var routineViewType = _.find(routineViewFilters, { id: idRoutineViewType });

         this.props.onChange(routineViewType);
         this.setState({ broadcast: false });
      }
   }

   render() {
      const { filters, idRoutineViewType, isOpen } = this.state;
      const { id } = this.props;

      var routineViewType = _.find(filters, { id: idRoutineViewType });

      const name = routineViewType ? routineViewType.name : '';

      const popupTarget = id ? id + '-routine-view-selector-spn' : 'routine-view-selector-spn';

      return (
         <div className='RoutineViewSelector'>
            {
               <span id={popupTarget} className='filter-link' onClick={this.handleToggle}>
                  {name}
               </span>
            }
            {isOpen && (
               <Popover
                  placement='bottom'
                  isOpen={isOpen}
                  target={popupTarget}
                  toggle={this.handleToggle}
                  className={'filter-selector-popover'}>
                  <PopoverBody>
                     <div style={{ height: 'auto', padding: '0px', overflowY: 'scroll' }}>
                        <div style={{ overflowX: 'hidden' }}>
                           <MenuList>
                              {filters.map((option) => (
                                 <MenuItem
                                    key={option.id}
                                    onClick={this.handleChange('idRoutineViewType')}
                                    value={option.id}
                                    selected={option.id === idRoutineViewType}>
                                    {option.name}
                                 </MenuItem>
                              ))}
                           </MenuList>
                        </div>
                     </div>
                  </PopoverBody>
               </Popover>
            )}
         </div>
      );
   }
}

RoutineViewSelector.defaultProps = {
   routineViewType: { id: 0 },
   onChange: () => {}
};

export default RoutineViewSelector;
